import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Contracts from "../Contracts";
import ContractNew from "../../admin/Contracts/ContractNew";
import Protector from "../../../router/Protector/Protector";
import NavigateToDefault from "../../../router/NavigateToDefault";

class ContractsRouter extends React.Component {

    render() {
        return (
            <Routes caseSensitive>
                <Route path="/" element={<Contracts />} sensitive />
                <Route path="/new-contract" exact element={<Protector><ContractNew /></Protector>} sensitive />
                <Route path="*" element={<NavigateToDefault/>} />
            </Routes>
        );
    }

}



export default ContractsRouter;